import { GitCommit, ExternalLink } from "lucide-react";
import { GithubCommit } from "@shared/types/WorkOrderDto";
import { formatDate } from "./utils";

export function CommitCard({ commit }: { commit: GithubCommit }) {
  return (
    <a
      href={commit.link}
      target="_blank"
      rel="noopener noreferrer"
      className="flex items-start gap-3 p-3 rounded-lg border border-border/50 hover:bg-card/50 hover:border-primary/30 transition-all"
    >
      <div className="w-8 h-8 rounded-lg bg-blue-500/10 flex items-center justify-center shrink-0">
        <GitCommit className="h-4 w-4 text-blue-500" />
      </div>
      <div className="flex-1 min-w-0">
        <p className="text-sm font-medium truncate">{commit.commitMessage}</p>
        <div className="flex items-center gap-2 mt-1 text-xs text-muted-foreground">
          <code className="bg-muted/50 px-1.5 py-0.5 rounded">
            {commit.shasum.slice(0, 7)}
          </code>
          <span>on {commit.branch}</span>
          <span>•</span>
          <span>{formatDate(commit.createdAt)}</span>
        </div>
      </div>
      <ExternalLink className="h-4 w-4 text-muted-foreground shrink-0" />
    </a>
  );
}
